export const DEFAULT_CARD_TEXT_MAX_WIDTH = "120ch";
export const DEFAULT_TEXT_PARAPGRAPH_MAX_WIDTH = "100ch";
